var height = require('..')
var demo = document.getElementById('demo')
var h = height(demo)
document.getElementById('height').textContent = h



/*****************
 ** WEBPACK FOOTER
 ** ./example/index.js
 ** module id = 0
 ** module chunks = 0
 **/